// extracted by mini-css-extract-plugin
export default {"card":"ManualEntry_card__nmIo7","input":"ManualEntry_input__qbaN-","button":"ManualEntry_button__mlFMC"};